<template>
  <div>
    <v-card>
      <v-toolbar class='mb-5'>
        <v-toolbar-title slot='extension' class='mb-5'>
        <div v-if='rootID !=0'>
          <div>
            <h3 class='body-3'>
              {{rootChildrenFetch.message}}
            </h3>
            <div class='caption'>
              {{rootChildrenFetch.user}}
              {{dateFormatter(rootChildrenFetch.timeStamp)}}
            </div>
          </div>
        </div>
        <div v-else>
          <h3 class='body-3'>
            {{projectName}} Community Discussion
          </h3>
        </div>
        <div>

        </div>
        <v-fab-transition>
        <v-btn
        small
        absolute
        round
        left
        bottom
        fab
        @click.native.stop='hiddenFab=!hiddenFab'
        color='success'>
      <v-icon>create</v-icon>
        </v-btn>
      </v-fab-transition>
        </v-toolbar-title>
        <v-btn flat icon @click.native='back' v-if='rootID != 0'>
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
      </v-toolbar>

    <v-container
      fluid
      style='min-height: 0;'
      grid-list-lg
    >
      <v-layout row wrap>
        <v-flex xs12
          v-for = '(value, child) in rootChildren'
          v-if = 'value'
          :key = 'child'>
          <recursive-chat-node
            :depth=0
            :chatNodeID = 'child'/>
        </v-flex>
      </v-layout>
    </v-container>
    </v-card>
    <v-dialog v-model='hiddenFab' max-width='800px'>
    <v-card>
      <v-form v-model='valid' ref='replyForm' @submit.prevent='addChild'>
        <v-layout row wrap>
          <v-flex xs12>
            <v-text-field
            v-model='chatMessage'
            :rules='chatMessageRules'
            required>
          </v-text-field>
        </v-flex>
        <v-flex xs4>
          <v-btn
          type='submit'
          :disabled='!valid'>
          Send
        </v-btn>
      </v-flex>
    </v-layout>
  </v-form>
</v-card>
</v-dialog>
  </div>
</template>
<!-- <template>
  <div>
    <v-card>
      <v-fab-transition>
      <v-btn slot='activator' absolute small round bottom left fab v-show='!hiddenFab'>
    <v-icon>reply</v-icon>
      </v-btn>
      </v-fab-transition>
      <v-card-title primary-title>
        <div v-if='rootID !=0'>
          <v-btn flat icon @click.native='back' >
            <v-icon>keyboard_arrow_left</v-icon>
          </v-btn>
          <div>
            <h3 class='body-3'>
              {{rootChildrenFetch.message}}
            </h3>
            <div class='caption'>
              {{rootChildrenFetch.user}}
              {{dateFormatter(rootChildrenFetch.timeStamp)}}
            </div>
          </div>
        </div>
        <div v-else>
          <h3 class='body-3'>
            {{projectName}} Community Chat
          </h3>
        </div>
        <v-menu transition='scale-transition'
        v-model='replyForm'
        :close-on-content-click='false'
        :full-width='true'
        :nudge-width='400'
        >

        <v-card>
          <v-form v-model='valid' ref='replyForm' @submit.prevent='addChild'>
            <v-layout row wrap>
              <v-flex xs8>
                <v-text-field
                v-model='chatMessage'
                :rules='chatMessageRules'
                required>
              </v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-btn
              type='submit'
              :disabled='!valid'>
              Send
            </v-btn>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card>
        </v-menu>
      </v-card-title>
    <v-container
      fluid
      style='min-height: 0;'
      grid-list-lg
    >
      <v-layout row wrap>
        <v-flex xs12
          v-for = '(value, child) in rootChildren'
          v-if = 'value'
          :key = 'child'>
          <recursive-chat-node
            :depth=0
            :chatNodeID = 'child'/>
        </v-flex>
      </v-layout>
    </v-container>
    </v-card>
  </div>
</template>
<script> -->
<script>
  import recursiveChatNode from './RecursiveChatNode.vue'
  import {db, fbTimeStamp} from '../../firebase/firebase'
  export default {
    data () {
      return {
        hiddenFab: false,
        replyForm: false,
        chatMessage: '',
        chatMessageRules: [
          v => !!v || 'Message can not be blank'
        ],
        valid: true
      }
    },
    firebase: function () {
      return {
        rootChildrenFetch: {
          source: db.ref('projects/' + this.$route.params.projectid + '/data/community/' + this.rootID),
          asObject: true
          // on exception fetch root node
        }
      }
    },
    watch: {
      rootID (value) {
        this.$unbind('rootChildrenFetch')
        this.$bindAsObject('rootChildrenFetch', db.ref('projects/' + this.$route.params.projectid + '/data/community/' + this.rootID))
      }
    },
    methods: {
      addChild () {
        var v = this.$firebaseRefs.rootChildrenFetch.parent.push({
          message: this.chatMessage,
          user: this.$store.getters.displayName,
          timeStamp: fbTimeStamp
        })
        this.$firebaseRefs.rootChildrenFetch.child('children').child(v.key).set('true')
        this.replyForm = false
        this.chatMessage = ''
        this.$refs.replyForm.reset()
        this.hiddenFab = false

        // if at root, add to properties field, else add to parent node
        // add chat node to data/chat using pushid
      },
      dateFormatter (date) {
        let fDate = 'Date Error'
        if (date) {
          fDate = new Date(date).toDateString()
        }
        return fDate
      },
      back () {
        this.$router.go(-1)
      }
    },
    computed: {
      rootChildren () {
      //  return {0: {children: {1: true, 2: true}}}
        return this.rootChildrenFetch.children
      },
      rootID () {
        if (this.$route.query['chatroot'] == null) {
          return 0
        } else {
          return this.$route.query['chatroot']
        }
      },
      projectName () {
        return this.$route.params.projectid
      }
    },
    components: {
      recursiveChatNode
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/community/Community.vue